import React from "react";

const safeUseReveal = () => {
  try {
    // @ts-ignore
    if (typeof useReveal === "function") return useReveal();
  } catch (e) {}
  return null;
};

const safeHide = (direction) => {
  try {
    // @ts-ignore
    if (typeof hide === "function") return hide(direction);
  } catch (e) {}
  return {};
};

const COOPERATION_INITIATIVES = [
  "Vocational and professional training",
  "Business culture exchange",
  "Responsible business practices",
  "Youth and entrepreneurship development",
  "Innovation and technology dialogue",
  "Stronger connections between private and institutional stakeholders",
];

export const StrategicSection = () => {
  const ref = safeUseReveal();

  return (
    <div className="w-full flex flex-col font-sans">
      {/* 1. WHY BANGLADESH & ITALY SECTION */}
      <section ref={ref} className="bg-white py-20 lg:py-28">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">

          <div className="text-center mb-12">
            <h2
              data-r
              style={safeHide("up")}
              className="text-4xl pb-4 md:text-5xl font-black text-[#0F1C35] leading-tight tracking-tight"
            >
              Why Bangladesh &amp; Italy?
            </h2>
          </div>

          <div
            data-r
            style={safeHide("up")}
            className="relative pl-8 space-y-10"
          >
            <p className="text-base md:text-lg text-gray-700 leading-relaxed font-normal">
              Bangladesh and Italy represent two highly complementary economies with strong opportunities for long-term cooperation across manufacturing, technology, logistics, design, furniture, ceramics, industrial solutions, sustainability and investment.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed font-normal">
              Bangladesh offers scale, manufacturing capacity, competitiveness, and a rapidly growing economy. Italy contributes advanced technology, engineering expertise, premium manufacturing, innovation, and global brand value.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed font-normal">
              BICCI aims to serve as a bridge between these two dynamic business ecosystems.
            </p>
          </div>

        </div>
      </section>

      {/* 2. ECONOMIC & INSTITUTIONAL COOPERATION SECTION */}
      <section className="bg-[#F8F9FA] py-20 lg:py-28 relative overflow-hidden">
        {/* Subtle Decorative Background */}
        <div className="absolute bottom-0 left-0 w-1/3 h-full bg-[#C9952A]/5 skew-x-12 -translate-x-20 pointer-events-none" />

        <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
          <div className="grid lg:grid-cols-2 gap-16 items-center">

            {/* Left Content */}
            <div data-r style={safeHide("right")}>
              <h2 className="text-3xl md:text-4xl font-black text-[#0F1C35] leading-tight mb-6">
                Economic & Institutional <br />
                <span className="text-[#0F1C35]">Cooperation</span>
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6 font-normal">
                Beyond trade and investment, BICCI aims to strengthen long-term economic and institutional relations between Bangladesh and Italy by encouraging knowledge exchange, professional development, and cross-cultural business collaboration.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed font-normal">
                Through these activities, BICCI seeks to promote a modern, inclusive, and forward-looking bilateral business ecosystem.
              </p>
            </div>

            {/* Right Content - Initiatives Grid */}
            <div data-r style={safeHide("left")} className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm">
              <h3 className="text-xl font-bold text-[#0F1C35] mb-6">
                The Chamber supports initiatives that contribute to:
              </h3>
              <ul className="space-y-4">
                {COOPERATION_INITIATIVES.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-4 group"
                  >
                    <div className="w-6 h-6 rounded-full bg-[#0F1C35]/5 group-hover:bg-[#0077b6]/20 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors duration-300">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#0F1C35]" />
                    </div>
                    <span className="text-base text-[#3D4A62] leading-relaxed font-normal">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default StrategicSection;